// extracted by mini-css-extract-plugin
export default {"root":"styles_root__2C3co","actionBtn":"styles_actionBtn__Qt0C4","minusBtn":"styles_minusBtn__-zGsI"};